import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import Grid from "@mui/material/Grid";
import { Typography, TextField } from "@mui/material";
import Button from "@mui/material/Button";
import { AdapterMoment } from "@mui/x-date-pickers/AdapterMoment";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import FormControl from "@mui/material/FormControl";
import MenuItem from "@mui/material/MenuItem";
import Select from "@mui/material/Select";
import ListItemText from "@mui/material/ListItemText";
import Checkbox from "@mui/material/Checkbox";
import Box from "@mui/material/Box";
import Chip from "@mui/material/Chip";
import IconButton from "@mui/material/IconButton";
import AddCircleIcon from "@mui/icons-material/AddCircle";
import RemoveCircleIcon from "@mui/icons-material/RemoveCircle";
import InputLabel from "@mui/material/InputLabel";
import moment from "moment";
import Root from "./../../../Components/Course/Root";
import ClassListModal from "./ClassList";
import { DayPicker } from "react-day-picker";
import "react-day-picker/dist/style.css";
import CalendarMonthIcon from "@mui/icons-material/CalendarMonth";

import { makeStyles } from "@material-ui/core/styles";
import { updateDefs, getDefs, createDefs } from "./../Services";
import { userLogs, getClassNames } from "./../../../Js/Common";
import { find, findIndex, map, set } from "lodash";

const daysList = [
  { value: "Sunday", id: 0 },
  { value: "Monday", id: 1 },
  { value: "Tuesday", id: 2 },
  { value: "Wednesday", id: 3 },
  { value: "Thursday", id: 4 },
  { value: "Friday", id: 5 },
  { value: "Saturday", id: 6 },
];

const daysListWithClasses = [
  { value: "Sunday", id: 0, classes: [] },
  { value: "Monday", id: 1, classes: [] },
  { value: "Tuesday", id: 2, classes: [] },
  { value: "Wednesday", id: 3, classes: [] },
  { value: "Thursday", id: 4, classes: [] },
  { value: "Friday", id: 5, classes: [] },
  { value: "Saturday", id: 6, classes: [] },
];

const CourseConfig = (props) => {
  // Hooks
  const dispatch = useDispatch();
  const navigation = useNavigate();
  const style = useStyles();

  // State
  let [startMonth, setStartMonth] = useState(null);
  let [startYear, setStartYear] = useState(null);

  let [endMonth, setEndMonth] = useState(null);
  let [endYear, setEndYear] = useState(null);
  let [minDate, setMinDate] = useState(null);
  let [maxDate, setMaxDate] = useState(null);
  let [selectedDate, setSelectedDate] = useState([]);

  let [startDate, setStartDate] = useState(null);
  let [endDate, setEndDate] = useState(null);
  let [startDatePicker, setStartDatePicker] = useState(moment());
  let [endDatePicker, setEndDatePicker] = useState(moment());
  let [selectedProduct, setSelectedProduct] = useState(null);
  let [selectedProductIndex, setSelectedProductIndex] = useState(0);
  let [classListModl, setClassListModl] = useState(false);
  let [defaultClassList, setDefaultClassList] = useState([]);

  let [currentModuleObj, setCurrentModuleObj] = useState(null);
  let [currentModuleObjSessions, setCurrentModuleObjSessions] = useState([]);
  let [languages, setLanguages] = useState([]);
  let [monthWiseLeave, setMonthWiseLeave] = useState([]);
  let [classWiseCourse, setClassWiseCourse] = useState([]);

  let [fullSavedData, setFullSavedData] = useState([]);
  let [savedDataCurrentPosition, setSavedDataCurrentPosition] = useState(0);
  let [savedDataUid, setSavedDataUid] = useState(null);
  let [currentSelectedSessions, setCurrentSelectedSessions] = useState([]);
  let [mode, setMode] = useState(null);
  let [allSessionChecked, setAllSessionChecked] = useState(false);

  let [initialRender, setInitialRender] = useState(true);
  let [classes, setClasses] = useState([]);
  let [selectedclass, setSelectedClass] = useState([]);
  let [daysOfWeek, setDaysOfWeek] = useState(daysListWithClasses);
  let [selectedDays, setSelectedDays] = useState(null);
  // let [daysOfWeekWithClasses, setDaysOfWeekWithClasses] =
  //   useState(daysListWithClasses);
  let [leavesWithDates, setLeavesWithDates] = useState([]);
  let [uniqLeavesWithDates, setUniqLeavesWithDates] = useState([]);

  // Redux state
  const userInfo = useSelector((state) => state.loggedInUserInfo.userInfo);
  const products = useSelector((state) => state.defs.siteConfig.products);
  const language = useSelector((state) => state.product.language);

  useEffect(() => {
    const innerFun = async () => {
      setClasses(await getClassNames(userInfo.site_uuid));
      let academicTermData = await getDefs({
        site_uuid: userInfo.site_uuid,
        keyid: "academicTermData",
      });
      if (academicTermData.data.data.length > 0) {
        let pos = findIndex(
          checkCurrentActive(academicTermData.data.data[0]["keydata"]),
          {
            isactive: true,
          }
        );
        console.log("pos", pos);
        if (pos > -1) {
          setMode("edit");
          setFullSavedData(academicTermData.data.data[0]["keydata"]);
          setSavedDataCurrentPosition(pos);
          setSavedDataUid(academicTermData.data.data[0]["uid"]);
          setUniqLeavesWithDates(
            academicTermData.data.data[0]["keydata"][pos][
              "uniqLeavesWithDates"
            ].map((val) => {
              return { ...val, date: moment(val.date) };
            })
          );
          setLeavesWithDates(
            academicTermData.data.data[0]["keydata"][pos][
              "uniqLeavesWithDates"
            ].map((val) => {
              return { ...val, date: moment(val.date) };
            })
          );
          setDaysOfWeek(
            academicTermData.data.data[0]["keydata"][pos][
              "daysOfWeekWithClasses"
            ]
          );
          setSelectedDate(
            academicTermData.data.data[0]["keydata"][pos]["selectedDates"]
          );
          setMonthWiseLeave(
            academicTermData.data.data[0]["keydata"][pos]["monthWiseData"]
          );
          setClassWiseCourse(
            academicTermData.data.data[0]["keydata"][pos]["classWiseCourse"]
          );
          setStartDate(
            academicTermData.data.data[0]["keydata"][pos]["startDate"]
          );
          setEndDate(academicTermData.data.data[0]["keydata"][pos]["endDate"]);
          let smoment = moment(
            new Date(academicTermData.data.data[0]["keydata"][pos]["startDate"])
          );
          let emoment = moment(
            new Date(academicTermData.data.data[0]["keydata"][pos]["endDate"])
          );
          setMinDate(smoment);
          setStartDatePicker(smoment);
          setEndDatePicker(emoment);
          setStartMonth(smoment.month());
          setStartYear(smoment.year());
          setEndMonth(emoment.month());
          setEndYear(emoment.year());
        } else {
          setMode("create");
        }
      } else {
        setMode("create");
      }
    };
    innerFun();
  }, [userInfo]);

  useEffect(() => {
    setSelectedProduct(products[0]["productId"]);
    checkPoductAddedOrNot(products[0]["productId"]);
  }, [products]);

  // useEffect(() => {
  //   if (leavesWithDates) {
  //     let temp = [...leavesWithDates];
  //     let uniqTemp = temp.reduce((acc, current) => {
  //       if (!acc.some((d) => d.date.isSame(current.date, "day"))) {
  //         acc.push(current);
  //       }
  //       return acc;
  //     }, []);
  //     setUniqLeavesWithDates(uniqTemp);
  //     calculateClassWiseWorkingDays(daysOfWeek, uniqTemp);
  //   }
  // }, [leavesWithDates]);

  useEffect(() => {}, [selectedDays]);

  const checkCurrentActive = (data) => {
    return data.map((val, ind) => {
      let d1 = new Date(val.startDate);
      let d2 = new Date(val.endDate);
      let d = new Date();
      if (d.getTime() < d2.getTime()) {
        return {
          ...val,
          isactive: true,
        };
      } else {
        return {
          ...val,
          isactive: false,
        };
      }
    });
  };

  const handleChangeStart = (date) => {
    let d = moment(date);
    setStartMonth(d.month());
    setStartYear(d.year());
    if (moment().diff(d, "days") < 0) {
      setMinDate(date);
      //setEndDatePicker(d);
    } else {
      setMinDate(moment());
    }
    setMaxDate(d.add(11, "month"));
  };

  const handleChangeEnd = (date) => {
    let d = moment(date);
    setEndMonth(d.month());
    setEndYear(d.year());
  };

  const addMonths = () => {
    let firstDay = new Date(+startYear, +startMonth, 1);
    let lastDay = new Date(+endYear, +endMonth + 1, 0);
    var startDate = moment(firstDay);
    var endDate = moment(lastDay);
    console.log("startDate", startDate);
    console.log("endDate", endDate);
    setStartDate(startDate.format("YYYY-MM-DD"));
    setEndDate(endDate.format("YYYY-MM-DD"));
    var betweenMonths = [];
    if (startDate < endDate) {
      var date = startDate.startOf("month");
      var diffmon = endDate.diff(startDate, "months");
      let count = 0;
      while (count <= diffmon) {
        console.log(
          "SSDFVVV",
          +countSundaysInMonth(+date.format("YYYY"), +date.format("M") - 1)
        );
        let pos = findIndex(monthWiseLeave, {
          month: date.format("MMM"),
          year: date.format("YYYY"),
        });
        let sundays;
        betweenMonths.push({
          monthNumber: date.format("M"),
          month: date.format("MMM"),
          year: date.format("YYYY"),
          leaves: pos > -1 ? +monthWiseLeave[pos]["leaves"] : 0,
          totalDaysInMonth: date.daysInMonth(),
          monthStartDate: date.startOf("month").format("YYYY-MM-DD"),
          monthEndDate: date.endOf("month").format("YYYY-MM-DD"),
          actualWorkingDayAfterLeaves:
            +date.daysInMonth() -
            (+countSundaysInMonth(+date.format("YYYY"), +date.format("M") - 1) +
              (pos > -1 ? +monthWiseLeave[pos]["leaves"] : 0)),
        });
        date.add(1, "month");
        count++;
      }
    }
    console.log("betweenMonths", betweenMonths);
    setMonthWiseLeave(betweenMonths);
  };

  function countSundaysInMonth(year, month) {
    // Month in moment.js is 0-indexed (0 = January, 11 = December)
    const startOfMonth = moment([year, month]);
    const daysInMonth = startOfMonth.daysInMonth();
    let sundayCount = 0;

    for (let day = 1; day <= daysInMonth; day++) {
      const currentDay = moment([year, month, day]);
      if (currentDay.day() === 0) {
        // 0 = Sunday
        sundayCount++;
      }
    }

    return sundayCount;
  }

  // const changeLeaves = (e, index) => {
  //   if (!isNaN()) {
  //     let tempArr = [...leavesWithDates];
  //     tempArr[index]["date"] = e;
  //   }
  // };

  const handleChangeLeaveDate = (date, index) => {
    let d = moment(date);
    let arr = [...leavesWithDates];
    arr[index]["date"] = d;
    arr[index]["dayOfWeek"] = d.day();
    setLeavesWithDates(arr);
  };

  // To change product
  const changeProduct = (event) => {
    setSelectedProduct(event.target.value);
    checkPoductAddedOrNot(event.target.value);
  };

  const checkPoductAddedOrNot = (id) => {
    let pos = findIndex(classWiseCourse, {
      productId: id,
    });
    if (pos == -1) {
      let foundObj = find(products, { productId: id });
      let tempArr = [...classWiseCourse];
      tempArr.push({
        productId: foundObj["productId"],
        productName: foundObj["productName"],
        data: [],
      });
      setClassWiseCourse(tempArr);
      setSelectedProductIndex(tempArr.length - 1);
    } else {
      setSelectedProductIndex(pos);
    }
  };

  const moduleSelected = (moduleObj, languagesFromRoot) => {
    console.log("moduleObj", moduleObj);
    setCurrentModuleObj(moduleObj);
    let tempSessions = moduleObj.data.map((val) => {
      return {
        id: val.id,
        value: val.value,
      };
    });
    console.log("tempSessions", tempSessions);
    setCurrentModuleObjSessions(tempSessions);
    setLanguages(languagesFromRoot);
    let tempArr = [...classWiseCourse];
    let prodPos = findIndex(tempArr, { productId: selectedProduct });
    let modulePos = findIndex(tempArr[prodPos]["data"], {
      moduleId: moduleObj.id,
      parentId: languagesFromRoot[language]["id"],
    });
    if (modulePos > -1) {
      setDefaultClassList(tempArr[prodPos]["data"][modulePos]["classes"]);
      setCurrentSelectedSessions(
        tempArr[prodPos]["data"][modulePos]["sessions"]
      );
      if (
        tempArr[prodPos]["data"][modulePos]["sessions"].length ==
        moduleObj.data.length
      ) {
        setAllSessionChecked(true);
      } else {
        setAllSessionChecked(false);
      }
    } else {
      setDefaultClassList([]);
      setCurrentSelectedSessions(tempSessions);
      setAllSessionChecked(true);
    }
    setClassListModl(true);
  };

  const bindModuleAndClass = (selectedClasses) => {
    let moduleFinalObj = {
      parentId: languages[language]["id"],
      parentValue: languages[language]["value"],
      moduleId: currentModuleObj.id,
      moduleValue: currentModuleObj.value,
      sessions: currentSelectedSessions,
      classes: selectedClasses,
    };

    let tempArr = [...classWiseCourse];
    let prodPos = findIndex(tempArr, { productId: selectedProduct });
    let modulePos = findIndex(tempArr[prodPos]["data"], {
      moduleId: currentModuleObj.id,
      parentId: languages[language]["id"],
    });
    if (modulePos == -1) {
      if (selectedClasses.length > 0) {
        tempArr[prodPos]["data"].push(moduleFinalObj);
      }
    } else {
      if (selectedClasses.length > 0) {
        tempArr[prodPos]["data"][modulePos] = moduleFinalObj;
      } else {
        tempArr[prodPos]["data"].splice(modulePos, 1);
      }
    }
    setClassWiseCourse(tempArr);
    setClassListModl(false);
    setCurrentModuleObj(null);
    setCurrentModuleObjSessions([]);
    setLanguages([]);
    setDefaultClassList([]);
  };

  const saveFinalData = async () => {
    let keydataarr = [];
    if (mode == "create") {
      keydataarr = [
        ...fullSavedData,
        {
          startDate: startDate,
          endDate: endDate,
          monthWiseData: monthWiseLeave,
          classWiseCourse: classWiseCourse,
          uniqLeavesWithDates: uniqLeavesWithDates,
          selectedDates: selectedDate,
          daysOfWeekWithClasses: daysOfWeek,
        },
      ];
    } else {
      keydataarr = [...fullSavedData];
      keydataarr[savedDataCurrentPosition] = {
        startDate: startDate,
        endDate: endDate,
        monthWiseData: monthWiseLeave,
        classWiseCourse: classWiseCourse,
        uniqLeavesWithDates: uniqLeavesWithDates,
        selectedDates: selectedDate,
        daysOfWeekWithClasses: daysOfWeek,
      };
    }
    keydataarr = checkCurrentActive(keydataarr);
    let dataToSave = {
      keyid: "academicTermData",
      keydata: keydataarr,
      site_uuid: userInfo.site_uuid,
      synced_at: null,
      is_synced: false,
    };

    if (mode == "create") {
      await createDefs(dataToSave, {});
    } else {
      await updateDefs(dataToSave, savedDataUid, userInfo.site_uuid);
    }
    navigation(-1);
  };

  // select session from list
  const selectSessions = (obj) => {
    if (obj == "all") {
      if (allSessionChecked) {
        setAllSessionChecked(false);
        setCurrentSelectedSessions([]);
      } else {
        setAllSessionChecked(true);
        setCurrentSelectedSessions(
          currentModuleObj.data.map((val) => {
            return {
              id: val.id,
              value: val.value,
            };
          })
        );
      }
    } else {
      let tempSessions = [...currentSelectedSessions];
      let pos = findIndex(tempSessions, { id: obj.id });
      if (pos == -1) {
        tempSessions.push(obj);
      } else {
        tempSessions.splice(pos, 1);
      }
      if (tempSessions.length == currentModuleObj.data.length) {
        setAllSessionChecked(true);
      } else {
        setAllSessionChecked(false);
      }
      setCurrentSelectedSessions(tempSessions);
    }
  };

  // select class from list
  const selectClass = (obj) => {
    let tempClasses = [...selectedclass];
    let pos = findIndex(tempClasses, { id: obj.id });
    if (pos == -1) {
      tempClasses.push(obj);
    } else {
      tempClasses.splice(pos, 1);
    }
    setSelectedClass(tempClasses);
    let tempArr = [...daysOfWeek];
    let selectedObjIndex = findIndex(tempArr, { id: selectedDays });
    tempArr[selectedObjIndex]["classes"] = tempClasses;
    setDaysOfWeek(tempArr);
    calculateClassWiseWorkingDays(tempArr, uniqLeavesWithDates);
  };

  // select days from list
  const setDays = (event) => {
    setSelectedDays(event.target.value);
    let tempArr = [...daysOfWeek];
    let selectedObjIndex = findIndex(tempArr, { id: event.target.value });
    setSelectedClass(tempArr[selectedObjIndex]["classes"]);
  };

  const addRemoveLeave = (type) => {
    let tempArr = [...leavesWithDates];
    if (type == "add") {
      tempArr.push({
        date: new Date(startDate),
        dayOfWeek: moment(new Date(startDate)).day(),
      });
    } else {
      tempArr.pop();
    }
    setLeavesWithDates(tempArr);
  };

  const addDateToSelection = (dates) => {
    console.log("date", dates);
    let temp = [...dates];
    let uniqTemp = temp.map((val) => {
      return { date: moment(val), dayOfWeek: moment(val).day() };
    });
    setUniqLeavesWithDates(uniqTemp);
    calculateClassWiseWorkingDays(daysOfWeek, uniqTemp);
    setSelectedDate(dates);
  };

  const calculateClassWiseWorkingDays = (daysWithClasses, uniqLeaves) => {
    let tempMonthwise = [...monthWiseLeave];
    const start = moment(startDate);
    const end = moment(endDate);

    const months = [];
    let current = start;

    while (current.isSameOrBefore(end)) {
      months.push(current.clone()); // keep a copy
      let daywiseLeaves = [0, 0, 0, 0, 0, 0, 0];
      let leavesInCurrentMonth = [];
      uniqLeaves.forEach((leave, lindex) => {
        if (leave.date.isSame(current, "month")) {
          leavesInCurrentMonth.push(leave);
          daywiseLeaves[+leave.dayOfWeek] =
            +daywiseLeaves[+leave.dayOfWeek] + 1;
        }
      });
      console.log("daywiseLeaves", tempMonthwise);
      console.log("classes", classes);
      let daysByClassFor = classes.map((cid, cindex) => {
        let days = map(
          daysWithClasses.filter((val, index) => {
            return find(val.classes, { id: cid.id });
          }),
          "id"
        );
        let daysList = days.map((val) => {
          return +countDaysByWeekInMonth(current, +val) - daywiseLeaves[+val];
        });
        let daysSum = daysList.reduce((acc, num) => acc + num, 0);
        return {
          ...cid,
          days: days,
          totalWorkingDays: daysSum,
        };
      });
      let foundIndex = findIndex(tempMonthwise, (o) => {
        return o.month == current.format("MMM") && +o.year == current.year();
      });
      tempMonthwise[foundIndex]["actualWorkingDayAfterLeaves"] = daysByClassFor;
      tempMonthwise[foundIndex]["leavesByWeekDays"] = daywiseLeaves;
      tempMonthwise[foundIndex]["leavesInCurrentMonth"] = leavesInCurrentMonth;
      current.add(1, "month");
    }

    setMonthWiseLeave(tempMonthwise);
    console.log("::::::", tempMonthwise);
  };

  function countDaysByWeekInMonth(momentObj, dayNum) {
    // month is 1-based (e.g. 8 for August)
    const start = momentObj.startOf("month");
    const end = moment(start).endOf("month");

    let count = 0;
    let current = moment(start);

    while (current.isSameOrBefore(end)) {
      if (current.day() === +dayNum) {
        // Monday = 1
        count++;
      }
      current.add(1, "day");
    }

    return count;
  }

  const removeLeave = (date) => {
    let temp = [...selectedDate];
    let pos = findIndex(temp, (d) => moment(d).isSame(moment(date), "day"));
    if (pos > -1) {
      temp.splice(pos, 1);
    }
    let uniqTemp = temp.map((val) => {
      return { date: moment(val), dayOfWeek: moment(val).day() };
    });
    setUniqLeavesWithDates(uniqTemp);
    calculateClassWiseWorkingDays(daysOfWeek, uniqTemp);
    setSelectedDate(temp);
  };

  return (
    <Grid container>
      {mode == "create" &&
      userInfo.rolesInfo.title.toLowerCase() == "incharge" ? (
        <Grid container justifyContent={"center"} mt={10}>
          <Typography variant="h5" color={"primary"}>
            Please contact CRM Team
          </Typography>
        </Grid>
      ) : (
        <>
          <Grid xs={12}>
            {mode && userInfo.rolesInfo.title.toLowerCase() == "admin" && (
              <Grid container>
                <Grid xs={5}>
                  <LocalizationProvider dateAdapter={AdapterMoment} def>
                    <FormControl
                      fullWidth
                      sx={{
                        mx: 1,
                        mb: 1,
                        borderRadius: 2,
                        borderColor: "#FFFFFF",
                        backgroundColor: "#F5F5F5",
                        color: "#D9D9D9",
                      }}
                      size="small"
                    >
                      <DatePicker
                        label={"Course Start Month and Year"}
                        views={["month", "year"]}
                        value={startDatePicker}
                        onChange={handleChangeStart}
                        disabled={mode != "create" ? true : false}
                        minDate={
                          mode == "create" ? "" : minDate ? minDate : moment()
                        }
                      />
                    </FormControl>
                  </LocalizationProvider>
                </Grid>
                <Grid xs={5} ml={1}>
                  <LocalizationProvider dateAdapter={AdapterMoment} def>
                    <FormControl
                      fullWidth
                      sx={{
                        mx: 1,
                        mb: 1,
                        borderRadius: 2,
                        borderColor: "#FFFFFF",
                        backgroundColor: "#F5F5F5",
                        color: "#D9D9D9",
                      }}
                      size="small"
                    >
                      <DatePicker
                        label={"Course End Month and Year"}
                        views={["month", "year"]}
                        value={endDatePicker}
                        onChange={handleChangeEnd}
                        minDate={minDate}
                        maxDate={maxDate}
                        disabled={mode != "create" ? true : false}
                      />
                    </FormControl>
                  </LocalizationProvider>
                </Grid>

                <Grid xs={1} textAlign={"center"}>
                  {startMonth != null &&
                    startYear != null &&
                    mode == "create" && (
                      <Button
                        sx={{
                          backgroundColor: "primary.main",
                          color: "#FFFFFF",
                          textTransform: "inherit",
                          borderRadius: 10,
                          fontWeight: "600",
                          mx: 1,
                         
                          "@media (min-width: 1636px)": {
                            fontSize: "1.2rem",
                            px: 2,
                          },
                        }}
                        size="large"
                        onClick={addMonths}
                      >
                        GO
                      </Button>
                    )}
                </Grid>
              </Grid>
            )}
            {/* <Confirmation
                image="delete"
                primaryText="Do you want to delete it?"
                visible={confirmModal}
                positiveClick={handleTopBtn}
                negativeClick={() => { setConfirmModal(false) }}
                toggleModal={(flag) => setConfirmModal(flag)}
            ></Confirmation> */}
          </Grid>
          {monthWiseLeave && monthWiseLeave.length > 0 && (
            <>
              <Grid xs={6} my={1} sx={{ flexDirection: "row" }}>
                <Typography
                  variant="caption"
                  color={"red"}
                  ml={2}
                  fontWeight={"bold"}
                >
                  NOTE :
                </Typography>
                <Typography variant="caption" color={"#888"}>
                  {" "}
                  Enter the leave dates excluding Sundays.
                </Typography>
              </Grid>
              <Grid xs={2} my={1}>
                <FormControl fullWidth size="small">
                  <InputLabel id="demo-simple-select-label">Days</InputLabel>
                  <Select
                    labelId="demo-simple-select-label"
                    id="demo-simple-select"
                    value={selectedDays}
                    inputProps={{ "aria-label": "Without label" }}
                    sx={{
                      borderRadius: 5,
                      borderColor: "#FFFFFF",
                      backgroundColor: "#F5F5F5",
                    }}
                    label="Age"
                    onChange={setDays}
                  >
                    {daysOfWeek &&
                      daysOfWeek.map((val, index1) => {
                        return <MenuItem value={val.id}>{val.value}</MenuItem>;
                      })}
                  </Select>
                </FormControl>
              </Grid>
              <Grid xs={2} my={1} ml={1}>
                <FormControl fullWidth sx={{ mb: 1 }} size="small">
                  <Select
                    value={selectedclass}
                    displayEmpty
                    inputProps={{ "aria-label": "Without label" }}
                    sx={{
                      borderRadius: 5,
                      borderColor: "#FFFFFF",
                      backgroundColor: "#F5F5F5",
                    }}
                    multiple
                    renderValue={(selected) => {
                      return map(selected, "value").join(", ");
                    }}
                  >
                    {classes &&
                      classes.map((val, index1) => {
                        return (
                          <Grid
                            container
                            justifyContent={"space-between"}
                            key={`${index1}_Class`}
                          >
                            <Grid item xs={2}>
                              <Checkbox
                                checked={
                                  findIndex(selectedclass, {
                                    id: val.id,
                                  }) > -1
                                }
                                onClick={() => selectClass(val)}
                              />
                            </Grid>
                            <Grid
                              item
                              xs={9}
                              sx={{ paddingTop: 0.8, cursor: "pointer" }}
                            >
                              <ListItemText
                                primary={val.value}
                                onClick={() => selectClass(val)}
                              />
                            </Grid>
                          </Grid>
                        );
                      })}
                  </Select>
                </FormControl>
              </Grid>
              <Grid xs={4} sx={{ flexDirection: "row", flexWrap: "wrap" }}>
                {/*<LocalizationProvider dateAdapter={AdapterMoment} def>
                      <FormControl
                        fullWidth
                        sx={{
                          mx: 1,
                          mb: 1,
                          borderRadius: 2,
                          borderColor: "#FFFFFF",
                          backgroundColor: "#F5F5F5",
                          color: "#D9D9D9",
                        }}
                        size="small"
                      >
                        <DatePicker
                          label={`Leave Date ${index + 1}`}
                          format="DD/MM/YYYY"
                          value={val.date}
                          onChange={(e) => {
                            handleChangeLeaveDate(e, index);
                          }}
                          minDate={moment(new Date(+startYear, +startMonth, 1))}
                          maxDate={moment(new Date(+endYear, +endMonth + 1, 0))}
                          shouldDisableDate={(date) => {
                            if (val.date && date.isSame(val.date, "day"))
                              return false;

                            return shouldDisableDate(date, index);
                          }}
                          slotProps={{
                            day: {
                              sx: {
                                "&.Mui-disabled": {
                                  color: "#fff !important", // change text color
                                  backgroundColor: "#999", // optional background
                                },
                              },
                            },
                          }}
                        /> 
                        
                      </FormControl>
                    </LocalizationProvider>*/}
                <DayPicker
                  mode="multiple"
                  selected={selectedDate}
                  onSelect={(s) => {
                    addDateToSelection(s);
                  }}
                  disabled={{
                    before: new Date(startDate),
                    after: new Date(endDate),
                  }}
                />
              </Grid>
              <Grid xs={7} ml={2}>
                <Typography variant="body1" color={"#888"}>
                  Selected Leave Dates ( {uniqLeavesWithDates.length} ):
                </Typography>
                <Box
                  className={style.scrollBar}
                  sx={{
                    mt: 1,
                    height: "35vh",
                    overflow: "auto",
                    flexDirection: "row",
                    flexWrap: "wrap",
                  }}
                >
                  {selectedDate &&
                    selectedDate.map((val, index) => {
                      return (
                        <Chip
                          icon={<CalendarMonthIcon />}
                          key={`${index}_Leave`}
                          label={moment(val).format("DD-MM-YYYY")}
                          sx={{ m: 0.5 }}
                          onDelete={() => {
                            removeLeave(val);
                          }}
                        />
                      );
                    })}
                </Box>
              </Grid>
              {/* <IconButton
                aria-label="delete"
                size="small"
                color="primary"
                onClick={() => {
                  addRemoveLeave("add");
                }}
              >
                <AddCircleIcon />
              </IconButton>
              {leavesWithDates && leavesWithDates.length > 0 && (
                <IconButton
                  aria-label="delete"
                  size="small"
                  color="secondary"
                  onClick={() => {
                    addRemoveLeave("remove");
                  }}
                >
                  <RemoveCircleIcon />
                </IconButton> */}
            </>
          )}
          <Grid xs={12}>
            <FormControl sx={{ mx: 1, mb: 1 }} size="small">
              <Select
                value={selectedProduct}
                onChange={changeProduct}
                displayEmpty
                inputProps={{ "aria-label": "Without label" }}
                sx={{
                  borderRadius: 5,
                  borderColor: "#FFFFFF",
                  backgroundColor: "#F5F5F5",
                  "@media (min-width: 1636px)": {
                    fontSize: "1.2rem",
                  },
                }}
              >
                {products &&
                  products.map((val, index) => {
                    return (
                      <MenuItem value={val.productId} key={`${index}_Product`}>
                        {val.productName}
                      </MenuItem>
                    );
                  })}
              </Select>
            </FormControl>
          </Grid>
          <Grid xs={12}>
            <Root
              selectClassOpen={moduleSelected}
              alreadySelected={
                classWiseCourse[selectedProductIndex]
                  ? map(
                      classWiseCourse[selectedProductIndex]["data"],
                      "moduleId"
                    )
                  : []
              }
            ></Root>
          </Grid>
          <Grid xs={12} textAlign={"center"}>
            <Button
              sx={{
                borderRadius: 10,
                backgroundColor: "primary.main",
                color: "#FFF",
                fontWeight: "bold",
                mt: 3,
                px: 2,
              
                "@media (min-width: 1636px)": {
                  fontSize: "1.4rem",
                },
              }}
              size="large"
              onClick={saveFinalData}
            >
              Save
            </Button>
            <Button
              variant="outlined"
              sx={{
                borderRadius: 10,
                fontWeight: "bold",
                mt: 3,
                px: 2,
                ml: 2,
               
              }}
              size="large"
              onClick={() => {
                navigation(-1);
              }}
            >
              Cancel
            </Button>
          </Grid>
        </>
      )}

      <ClassListModal
        visible={classListModl}
        sessions={currentModuleObjSessions ? currentModuleObjSessions : []}
        selectedSessions={
          currentSelectedSessions ? currentSelectedSessions : []
        }
        selectSession={selectSessions}
        moduleValue={currentModuleObj ? currentModuleObj.value : ""}
        toggleModal={(flag) => {
          setClassListModl(flag);
          setCurrentModuleObj(null);
          setCurrentModuleObjSessions([]);
          setLanguages([]);
          setDefaultClassList([]);
        }}
        selectAllChecked={() => {
          selectSessions("all");
        }}
        allSessionChecked={allSessionChecked}
        defaultClassList={defaultClassList}
        go={bindModuleAndClass}
      ></ClassListModal>
    </Grid>
  );
};

const useStyles = makeStyles({
  scrollBar: {
    "&::-webkit-scrollbar": {
      width: "0.6em",
    },
    "&::-webkit-scrollbar-track": {
      backgroundColor: "#ffe600ff",
      "-webkit-box-shadow": "inset 0 0 6px rgba(0,0,0,0.00)",
      borderRadius: 5,
    },
    "&::-webkit-scrollbar-thumb": {
      backgroundColor: "#5f5600ff",
      borderRadius: 5,
    },
  },
});
export default CourseConfig;
